// --------------------------------------------------------------
// Created On: 2021-09-01
// Author: Zachary Thomas
//
// Last Modified: 2026-10-02
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Card from "../../../components/Card/Card";

// A card for letting users know that register access isn't supported for this asset.
export default function RegisterAccessNotSupportedCard(props: Props): Component {
  return (
    <Card title={`${props.assetName} Modbus Read/Write`} isLeftAligned>
      {props.loading ? (
        <div className="my-5 py-5" />
      ) : (
        <p className="h4 text-center py-5 px-4">
          {props.deviceSupportsControllerConfiguration
            ? "You do not have the permission to write or read directly from registers for this asset."
            : "This asset does not support direct register reads and writes."}
        </p>
      )}
    </Card>
  );
}

interface Props {
  assetName: string;
  deviceSupportsControllerConfiguration: boolean;
  loading: boolean;
}
